import { Component, OnInit, ViewChild } from '@angular/core';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { ProductViewComponent } from 'src/app/components/productos/product-view/product-view.component';
import { ParametroModel } from 'src/app/shared/models/producto/parametro.model';
import { ProductoModel, Data as DataProducto } from 'src/app/shared/models/producto/producto.model';
import { AuthService } from 'src/app/shared/services/auth/auth.service';
import { ConfigService } from 'src/app/shared/services/config.service';
import { ProductoService } from 'src/app/shared/services/producto/producto.service';
import { NavService, Menu } from '../../../../services/nav.service';

@Component({
  selector: 'app-search',
  templateUrl: './search.component.html',
  styleUrls: ['./search.component.scss']
})
export class SearchComponent implements OnInit {

  public menuItems: Menu[];
  public items: Menu[];

  products: DataProducto[] = [];

  temp: DataProducto[] = [];

  public searchResult: boolean = false;
  public searchResultEmpty: boolean = false;
  public text: string;

  // SC CATWEB-396 Se define variable para indicar el total de articulos retornados.
  public totalItems : number = 0; 

  private cant_caracter = this.configService.config.productos?.cant_min_caracter;
  private cant_search = this.configService.config.productos?.cant_product_search;
  public textSearch: string = "";

  private datos: ParametroModel = {
    PageNumber: 1,
    PageSize: this.cant_search,
    ConStock: 'S',
    IncluyeSubFamilia: 'S',
    SoloConAplic:'N',
    IdPlataforma: this.authService.usuario.id_plataforma
  };
  public verPrecios =
    this.configService.config.productos.ver_precios == 0 ||
    !this.authService.usuario.invitado;

    // SC CATFER-27  propiedades para definir si se muestran los precios en el vista modal.
  public muestraNeto =
    this.configService.config.productos?.muestra_precio_neto && this.verPrecios;
  public muestraFinal =
    this.configService.config.productos?.muestra_precio_final &&
    this.verPrecios;
  public muestraLista =
    this.configService.config.productos?.muestra_precio_lista &&
    this.verPrecios;

  @ViewChild('quickView') QuickView: ProductViewComponent;

  constructor(public navServices: NavService, 
    private productoService: ProductoService,
    private configService: ConfigService,
    private authService: AuthService,
    private modalService: NgbModal) {
    this.navServices.items.subscribe(menuItems => this.items = menuItems);
  }

  ngOnInit() {
    this.textSearch = this.configService.config.productos.title_search;
  }

  searchToggle() {
    this.navServices.search = false;
    //this.removeFix();
  }

  irProductos(){
    this.navServices.search = false;
    this.removeFix();
  }

  searchTerm(term: any) {
    console.log(term);

    term ? this.addFix() : this.removeFix();
    if (!term) return this.products = [];
    let items = [];
    term = term.trim().toLowerCase();
    this.datos.BusquedaMultiple = term.replace(/ de | y | o | con /g," ").replace(/ /g,"|");
    if (term.length >= this.cant_caracter!) {
      //setTimeout(() => {
        this.onSearch();
      //}, 3000);
      
    }
    this.items.filter(menuItems => {
      if (!menuItems?.title) return false
      if (menuItems.title.toLowerCase().includes(term) && menuItems.type === 'link') {
        items.push(menuItems);
      }
      if (!menuItems.children) return false
      menuItems.children.filter(subItems => {
        if (subItems.title.toLowerCase().includes(term) && subItems.type === 'link') {
          subItems.icon = menuItems.icon
          items.push(subItems);
        }
        if (!subItems.children) return false
        subItems.children.filter(suSubItems => {
          if (suSubItems.title.toLowerCase().includes(term)) {
            suSubItems.icon = menuItems.icon
            items.push(suSubItems);
          }
        })
      })
      this.checkSearchResultEmpty(items)
      this.menuItems = items
    });
  }

  checkSearchResultEmpty(items) {
    if (!items.length)
      this.searchResultEmpty = true;
    else
      this.searchResultEmpty = false;
  }

  addFix() {
    this.searchResult = true;
    document.getElementsByTagName('body')[0].classList.add('offcanvas');
  }

  removeFix() {
    this.searchResult = false;
    this.text = "";
    this.products = [];
    document.getElementsByTagName('body')[0].classList.remove('offcanvas');
  }

  // SC CATFER-27 adaptar los nombres de las propiedades del modelo producto.model, para setear el arreglo de productos de la busqueda y el total de registro.
  onSearch() {
    const susc = this.productoService
      .getProductos(this.datos)
      .subscribe((data) => {
        if (data.Succeeded) {
          this.temp = [...data.Data];
          // this.products = data.Data;
          if(data.Data.length > 0){
            this.products = data.Data;
            this.totalItems = data.TotalRecords;
          }
          this.checkSearchResultEmpty(this.products);
        }
       
      });
    susc.unsubscribe;
  }

}